import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { unattendedService } from '@/api/services/unattendedService'

export function useUnattendedStudents(p?: Parameters<typeof unattendedService.list>[0]) {
  return useQuery({ queryKey: ['unattended', p], queryFn: () => unattendedService.list(p), staleTime: 30_000 })
}
export function useApproveRejectUnattended() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => unattendedService.approveOrReject(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['unattended'] }) })
}
